import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import $ from 'jquery';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  constructor(private router: Router, @Inject(DOCUMENT) private document: Document) { }
  menuItems = [
    { id: 'reports', link: '/suzuki/reports', title: 'Reports', img: 'age_group_icon', selectedImg: 'age_group_icon_selected', subMenuItems: [] },
    { id: 'users', link: '/suzuki/users', title: 'Users', img: 'age_group_icon', selectedImg: 'age_group_icon_selected', subMenuItems: [] },
    { id: 'age-group', link: '/suzuki/age-group', title: 'Age Group', img: 'age_group_icon', selectedImg: 'age_group_icon_selected', subMenuItems: [] },
    { id: 'gender', link: '/suzuki/gender', title: 'Gender', img: 'age_group_icon', selectedImg: 'age_group_icon_selected', subMenuItems: [] },
    { id: 'customer-type', link: '/suzuki/customer-type', title: 'Customer Type', img: 'customer_type_icon', selectedImg: 'customer_type_icon_selected', subMenuItems: [] },
    { id: 'customer-title', link: '/suzuki/customer-title', title: 'Customer Title', img: 'customer_type_icon', selectedImg: 'customer_type_icon_selected', subMenuItems: [] },
    { id: 'file-type', link: '/suzuki/file-type', title: 'File Type', img: 'customer_type_icon', selectedImg: 'customer_type_icon_selected', subMenuItems: [] },
    // { id: 'license-code', link: '/suzuki/license-code', title: 'License Code', img: 'license_code_icon', selectedImg: 'license_code_icon_selected', subMenuItems: [] },
    { id: 'ms-pin', link: '/suzuki/ms-pin', title: 'SMPIN', subMenuItems: [] },
    { id: 'service-advisor', link: '/suzuki/service-advisor', title: 'Service Advisor', img: 'outlet_icon', selectedImg: 'outlet_icon_selected', subMenuItems: [] },
    { id: 'dealer', link: '/suzuki/dealer', title: 'Parent Dealer', img: 'parent_dealer_icon', selectedImg: 'parent_dealer_icon_selected', subMenuItems: [] },
    { id: 'outlet', link: '/suzuki/outlet', title: 'Outlet', img: 'outlet_icon', selectedImg: 'outlet_icon_selected', subMenuItems: [] },
    { id: 'occupation', link: '/suzuki/occupation', title: 'Occupation', img: 'occupation_icon', selectedImg: 'occupation_icon_selected', subMenuItems: [] },
    { id: 'role', link: '/suzuki/role', title: 'Role', img: 'role_icon', selectedImg: 'role_icon_selected', subMenuItems: [] },
    { id: 'virtual-number', link: '/suzuki/virtual-number', title: 'Virtual Number', img: 'virtual_number_icon', selectedImg: 'virtual_number_icon_selected', subMenuItems: [] },
    { id: 'level-master', link: '/suzuki/level-master', title: 'Level Master', subMenuItems: [] },
    { id: 'likehood-purchase-master', link: '/suzuki/likehood-purchase-master', title: 'LikeHood Purchase Master', subMenuItems: [] },
    { id: 'customer-requirement', link: '/suzuki/customer-requirement', title: 'Customer Requirement', subMenuItems: [] },
    { id: 'delivery-preference', link: '/suzuki/delivery-preference', title: 'Delivery Preference', subMenuItems: [] },
    { id: 'payment-method', link: '/suzuki/payment-method', title: 'Payment Method', subMenuItems: [] },
    { id: 'customer-interest', link: '/suzuki/customer-interest', title: 'Customer Interest', subMenuItems: [] },
    { id: 'vn-mapping', link: '/suzuki/vn-mapping', title: 'VN-Mapping', subMenuItems: [] },
    { id: 'mode-of-contact', link: '/suzuki/mode-of-contact', title: 'Mode of Contact', img: 'mode_of_contact', selectedImg: 'modeof_contact_icon_selected', subMenuItems: [] },
    { id: 'follow-up-status', link: '/suzuki/followup-status', title: 'Follow-up status', img: 'follow_up_icon', selectedImg: 'follow_up_icon_selected' , subMenuItems: [] },
    { id: 'oem', link: '/suzuki/oem', title: 'OEM Competitor', img: 'follow_up_icon', selectedImg: 'follow_up_icon_selected' , subMenuItems: [] },
    { id: 'lost-model', link: '/suzuki/lost-model', title: 'Lost Model', img: 'follow_up_icon', selectedImg: 'follow_up_icon_selected' , subMenuItems: [] },
    { id: 'checklist', link: '/suzuki/checklist', title: 'Check List', img: 'follow_up_icon', selectedImg: 'follow_up_icon_selected' , subMenuItems: [] },
    { id: 'customer-feedback', link: '/suzuki/customer-feedback', title: 'Customer Feedback', img: 'follow_up_icon', selectedImg: 'follow_up_icon_selected' , subMenuItems: [] },
    { id: 'corporate', link: '/suzuki/corporate', title: 'Corporate', img: 'follow_up_icon', selectedImg: 'follow_up_icon_selected' , subMenuItems: [] },
    { id: 'CommunicateTo', link: '/suzuki/communicate-to', title: 'Communicate To', img: 'follow_up_icon', selectedImg: 'follow_up_icon_selected' , subMenuItems: [] },
    { id: 'customer-followup', link: '/suzuki/customer-followup', title: 'Customer Followup', img: 'follow_up_icon', selectedImg: 'follow_up_icon_selected' , subMenuItems: [] },
    { id: 'customer-category', link: '/suzuki/customer-category', title: 'Customer Category', img: 'follow_up_icon', selectedImg: 'follow_up_icon_selected' , subMenuItems: [] },
    { id: 'terms', link: '/suzuki/terms', title: 'Terms', img: 'age_group_icon', selectedImg: 'age_group_icon_selected', subMenuItems: [] },
    { id: 'nonsales', link: '/suzuki/non-sales-category', title: 'Non Sales Category', img: 'age_group_icon', selectedImg: 'age_group_icon_selected', subMenuItems: [] },
    { id: 'price', link: '/suzuki/price', title: 'Price', img: 'age_group_icon', selectedImg: 'age_group_icon_selected', subMenuItems: [] },
    {
      id: 'location-group',
      title: 'Location Management',
      img: 'location_icon',
      selectedImg: 'location_icon_selected',
      subMenuItems: [
        { id: 'country', link: '/suzuki/country', title: 'Country', img: 'country_icon', selectedImg: 'country_icon_selected' },
        { id: 'zone', link: '/suzuki/zone', title: 'Zone', img: 'zone_icon', selectedImg: 'zone_icon_selected' },
        { id: 'state', link: '/suzuki/state', title: 'State', img: 'state_icon', selectedImg: 'state_icon_selected' },
        { id: 'region', link: '/suzuki/region', title: 'Region', img: 'region_icon', selectedImg: 'region_icon_selected' },
        { id: 'district', link: '/suzuki/district', title: 'District', img: 'district_icon', selectedImg: 'district_icon_selected' },
        { id: 'area', link: '/suzuki/area', title: 'Area', img: 'area_icon', selectedImg: 'area_icon_selected' },
        { id: 'location', link: '/suzuki/location', title: 'Location', img: 'location_icon', selectedImg: 'location_icon_selected' }
      ]
    },
    {
      id: 'lead-management',
      title: 'Lead Management',
      img: 'lead_management_icon',
      selectedImg: 'lead_management_icon_selected',
      subMenuItems: [
        { id: 'lead-status', link: '/suzuki/lead-status', title: 'Lead Status', img: 'lead_status_icon', selectedImg: 'lead_status_icon_selected' },
        { id: 'lead-stage', link: '/suzuki/lead-stage', title: 'Lead Stage', img: 'lead_stage_icon', selectedImg: 'lead_stage_icon_selected' },
        { id: 'lead-source', link: '/suzuki/lead-source', title: 'Lead Source', img: 'lead_source_icon', selectedImg: 'lead_source_icon_selected' },
        { id: 'lead-subsource', link: '/suzuki/lead-subsource', title: 'Lead Sub Source', img: 'lead_subsource_icon', selectedImg: 'lead_subsource_icon_selected' },
        { id: 'lead-type', link: '/suzuki/lead-type', title: 'Lead Type', img: 'lead_type_icon', selectedImg: 'lead_type_icon_selected' },
        { id: 'lead-priority', link: '/suzuki/lead-priority', title: 'Lead Priority', subMenuItems: [] }
      ]
    },
    {
      id: 'reason-management',
      title: 'Reason Management',
      img: 'customer_management_icon',
      selectedImg: 'customer_management_icon_selected',
      subMenuItems: [
        { id: 'follow-up', link: '/suzuki/follow-up-reason', title: 'Follow-up Reason', img: 'follow_up_icon', selectedImg: 'follow_up_icon_selected' },
        { id: 'pre-sales-lost', link: '/suzuki/presales-lost-reason', title: 'Pre Sales Reason', img: 'pre_sales_lost_icon', selectedImg: 'pre_sales_lost_icon_selected' },
        { id: 'sales-lost', link: '/suzuki/sales-lost-reason', title: 'Sales Lost Reason', img: 'sales_lost_icon', selectedImg: 'sales_lost_icon_selected' },
        { id: 'junk-reason', link: '/suzuki/junk-reason', title: 'Junk Reason', img: 'junk_reason_icon', selectedImg: 'junk_reason_icon_selected' },
        { id: 'no-response-reason', link: '/suzuki/no-response-reason', title: 'No Response Reason', img: 'no_response_reason_icon', selectedImg: 'no_response_reason_icon_selected' },
        { id: 'sales-follow-reason', link: '/suzuki/sales-follow-reason', title: 'Sales Follow Reason', img: 'sales_follow_reason', selectedImg: 'salesfollowup_reason_icon_selected' },
        { id: 'postponed-reason', link: '/suzuki/postponed-reason', title: 'Postponed Reason', img: 'postponed_reason', selectedImg: 'postponed_reason_icon_selected' },
        { id: 'sub-reason', link: '/suzuki/sub-reason', title: 'Sub Reason', img: 'no_response_reason_icon', selectedImg: 'no_response_reason_icon_selected' },
        { id: 'product-lost-reason', link: '/suzuki/product-lost-reason', title: 'Product Lost Reason', img: 'sales_lost_icon', selectedImg: 'sales_lost_icon_selected' },
        { id: 'product-lost-sub-reason', link: '/suzuki/product-lost-sub-reason', title: 'Product Lost Sub Reason', img: 'no_response_reason_icon', selectedImg: 'no_response_reason_icon_selected' },
      ]
    },
    {
      id: 'product-management',
      title: 'Product Management',
      img: 'product_management_icon',
      selectedImg: 'product_management_icon_selected',
      subMenuItems: [
        { id: 'product-category', link: '/suzuki/product-category', title: 'Product Category', img: 'product_category_icon', selectedImg: 'product_category_icon_selected' },
        { id: 'product-color', link: '/suzuki/product-color', title: 'Product Color', img: 'product_color_icon', selectedImg: 'product_color_icon_selected' },
        { id: 'product-model', link: '/suzuki/product-model', title: 'Product Model', img: 'product_model_icon', selectedImg: 'product_model_icon_selected' },
        { id: 'product-variant', link: '/suzuki/product-varient', title: 'Product Variant', img: 'product_variant_icon', selectedImg: 'product_variant_icon_selected' }
      ]
    },
  ];


  // menuItems = [
  //   { id: 'age-group', link: '/suzuki/age-group', title: 'Age Group', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'area', link: '/suzuki/area', title: 'Area', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   // { id: 'clients', link: '/suzuki/clients', title: 'Clients', img: 'leads', selectedImg: 'all_lead_selected' },
  //   { id: 'country', link: '/suzuki/country', title: 'Country', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'customer-type', link: '/suzuki/customer-type', title: 'Customer Type', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'district', link: '/suzuki/district', title: 'District', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'follow-up', link: '/suzuki/follow-up-reason', title: 'Follow-up Reason', img: 'leads', selectedImg: 'all_lead_selected' },
  //   { id: 'junk-reason', link: '/suzuki/junk-reason', title: 'Junk Reason', img: 'leads', selectedImg: 'all_lead_selected' },
  //   { id: 'no-response-reason', link: '/suzuki/no-response-reason', title: 'No Response Reason', img: 'leads', selectedImg: 'all_lead_selected' },
  //   { id: 'lead-status', link: '/suzuki/lead-status', title: 'Lead Status', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'lead-stage', link: '/suzuki/lead-stage', title: 'Lead Stage', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'lead-source', link: '/suzuki/lead-source', title: 'Lead Source', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'lead-subsource', link: '/suzuki/lead-subsource', title: 'Lead Sub Source', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'lead-type', link: '/suzuki/lead-type', title: 'Lead Type', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'license-code', link: '/suzuki/license-code', title: 'License Code', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'location', link: '/suzuki/location', title: 'Location', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'occupation', link: '/suzuki/occupation', title: 'Occupation', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'outlet', link: '/suzuki/outlet', title: 'Outlet', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'dealer', link: '/suzuki/dealer', title: 'Parent Dealer', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'pre-sales-lost', link: '/suzuki/presales-lost-reason', title: 'Pre Sales Reason', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'product-category', link: '/suzuki/product-category', title: 'Product Category', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'product-color', link: '/suzuki/product-color', title: 'Product Color', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'product-model', link: '/suzuki/product-model', title: 'Product Model', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'product-variant', link: '/suzuki/product-varient', title: 'Product Varient', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'region', link: '/suzuki/region', title: 'Region', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'role', link: '/suzuki/role', title: 'Role', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'sales-lost', link: '/suzuki/sales-lost-reason', title: 'Sales Lost Reason', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'state', link: '/suzuki/state', title: 'State', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'virtual-number', link: '/suzuki/virtual-number', title: 'Virtual-Number', img: 'create_lead', selectedImg: 'create_lead_selected' },
  //   { id: 'zone', link: '/suzuki/zone', title: 'Zone', img: 'create_lead', selectedImg: 'create_lead_selected' },
  // ];
  filteredMenuItems = [...this.menuItems];
  ngOnInit() {
    this.document.body.classList.add('logged-in-background');
    this.selectedTarget = this.router.url.split("/")[2]

  }

  applyFilter(event: any) {
    const lowerCaseFilter = event.target.value.toLowerCase();
    if (lowerCaseFilter) {
      this.filteredMenuItems = this.menuItems.filter((item: any) => {
        // Check if the main item matches the filter
        const mainItemMatches = item.title.toLowerCase().includes(lowerCaseFilter);

        // Filter sub-menu items based on the filter
        if (item.subMenuItems && item.subMenuItems.length > 0) {
          const filteredSubMenuItems = item.subMenuItems.filter((subItem: any) =>
            subItem.title.toLowerCase().includes(lowerCaseFilter)
          );

          // Update the subMenuItems of the main item
          item.filteredSubMenuItems = filteredSubMenuItems;

          // Return true if the main item matches or any sub-menu items match
          return mainItemMatches || filteredSubMenuItems.length > 0;
        }

        // Return true if the main item matches and it has no sub-menu items
        return mainItemMatches;
      });
    } else {
      // If the filter is empty, reset to the original menu items
      this.filteredMenuItems = this.menuItems.map((item: any) => ({
        ...item,
        filteredSubMenuItems: item.subMenuItems,
      }));
    }
  }


  selectedTarget: any = ''
  setActive(TARGETNAME: any): void {
    this.selectedTarget = TARGETNAME;
    let spliedClass: any = document.getElementById(TARGETNAME)?.className.split(" ")
    if (spliedClass[2] == 'active' || spliedClass[3] == 'active') {
      document.getElementById(TARGETNAME)!.classList.remove("active");
    }
    else {
      document.getElementById(TARGETNAME)!.classList.add('active');
    }
  }

  isCollapsed: boolean = false;
  $: any;
  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    $("body").toggleClass("fullcontent");
  }

  toggleSubMenu(itemId: string) {
    this.selectedTarget = this.selectedTarget === itemId ? '' : itemId;
  }

}
